import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../Pages";
import Dashboard from "../Pages/admin/Dashboard";
import AllProjectsPage from "../Pages/AllProjectsPage";
import BlogPage from "../Pages/BlogPage";
import BlogPostDetail from "../Pages/BlogPostDetail";
import UnsubscribePage from "../Pages/UnsubscribePage";

const RouteNavigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/projects" element={<AllProjectsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostDetail />} />
        <Route path="/unsubscribe" element={<UnsubscribePage />} />
      </Routes>
    </BrowserRouter>
  );
};
export default RouteNavigation;
